<template>
  <section class="acquisto-veloce" >


    <div class="container-c">
      <div class="header">
        <img :src="url('/media/icons/svg/cart1.svg')" alt="cart icon">
        <span>{{ trans.get('b2b.quick_purchase.quick_purchase') }}</span>
        <span class="close" >
        <img :src="url('/media/icons/svg/close.svg')"
             @click="closeAv"
             alt="close icon">
      </span>
      </div>
      <div class="cart-body">
        <avCard
            v-for="(articolo, key) in articoli"
            :key="key"
            :chiave="key"
            :unita_misura="articolo.unita_misura"
            :cod_art="articolo.cod_art"
            :qtaimballo="articolo.qta_per_imballo"
            @forCart="forCart"
        />
      </div>

      <div class="checkout">
        <a class="link-ret green av" @click="addToCart">{{ trans.get('b2b.quick_purchase.add-cart') }}</a>
      </div>
    </div>
  </section>
</template>

<script>
import avCard from './av-card'
export default {
  name: "acquisto-veloce",
  components: {
    avCard
  },
  data: function () {
    return {
      products: null,
      articoli: null,
      toCart: [],

    }
  },
  mounted() {

  },
  watch: {
    '$store.state.aVproducts': function () {
      this.products = this.$store.state.aVproducts
      this.getArticles()
    },

  },
  methods: {

    addToCart: function () {
      this.toCart.forEach((item) => {

        this.$store.dispatch('addItemToCart', {
          codart: item.articolo,
          quantita: item.quantita,
          prezzo: item.prezzo,
          prezzo_unitario: item.prezzo_unitario,
        })
        //this.$store.dispatch('refreshCart')
      })

      // this.$buefy.toast.open({
      //   message: `Articoli aggiunti correttamente al carrello!`,
      //   duration: 5000,
      //   type: 'is-success'
      // })
      this.closeAv()
      this.$store.commit('openCart')
    },
    forCart: function (value) {
      if (value.selected){
        const index = this.toCart.findIndex(item => item.articolo === value.articolo);
        if (index >= 0){

          this.toCart[index] = value
        } else {

          this.toCart.push(value)

        }


      } else {
        //console.log(value.selected, value.key, value.articolo)
        const index = this.toCart.findIndex(item => item.articolo === value.articolo);

        this.toCart.splice(index, 1)
      }

    },
    closeAv: function () {
      this.$store.dispatch('refreshAv');
      this.$emit('closeAv', true)
    },
    getArticles: function () {
      if(this.products.color !== null){
        axios({ //se ha colore
          method: 'get',
          url: window.location.origin + '/b2b/searchAV',
          params: {
            famiglia: this.products.family,
            categoria: this.products.category,
            colore: this.products.color
          }
        })
            .then(result =>{

              this.articoli = result.data

            })
            .catch(err =>{
              console.log(err)
            })
      } else if (this.products.cod_art){
        axios({ //se è senza categoria
          method: 'get',
          url: window.location.origin + '/b2b/searchAV',
          params: {
            uncat: true,
            cod_art: this.products.cod_art
          }
        })
            .then(result =>{

              this.articoli = result.data

            })
            .catch(err =>{
              console.log(err)
            })
      }
      else {
        axios({ //se non ha colore
          method: 'get',
          url: window.location.origin + '/b2b/searchAV',
          params: {
            famiglia: this.products.family,
            categoria: this.products.category
          }
        })
            .then(result =>{
              //console.log('no colore')
              this.articoli = result.data
            })
            .catch(err =>{
              console.log(err)
            })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.acquisto-veloce {
  margin-right: auto;
  width: 100%;
 height: 100%;
 .link-ret{
   max-width: unset;
 }

  background-color: #ffffff;

  .container-c {
    display: flex;
    flex-direction: column;
    height: 100%;
    @media (orientation: landscape) and (max-width: 1400px){
      height: calc(100vh - 80px)
    }

    .header {
      display: flex;
      align-items: center;
      padding: 23px 40px;
      border-bottom: 2px solid #D8D8D8;

      img {
        display: inline-block;
        width: 22px;
        filter: brightness(0);
        margin-right: 25px;
      }

      span {
        display: inline-block;
        font-size: 24px;
      }

      .close {
        margin-left: auto;
        cursor: pointer;

        img {
          width: 15px;
          filter: brightness(0);
        }
      }
    }

    .cart-body {
      display: flex;
      flex-direction: column;
      align-items: center;
      //max-height: calc(100vh - 275px);
      overflow-y: auto;
      overflow-x: hidden;
      -webkit-overflow-scrolling: touch;
      width: auto;
      height: 100%;

    }

    .totale {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 15px;
      background-color: var(--black-2);
      color: #ffffff;
      margin-top: auto;
      padding: 37px 62px;
      height: 70px;

      .total-price {
        margin-left: auto;
      }
    }

    .checkout {
     margin-top: auto;
      a {
        border: none;
        padding: 37px 62px;
        width: 100%;
        height: 70px;
      }
    }
  }

}
</style>
